import React from 'react'
import { Link } from 'react-scroll';
import {useTypewriter} from 'react-simple-typewriter'
import './HeroSection.css'
import VideoPlayer from '../VideoPlayer';

function HeroSection({topline, toplineSpan, headline, description, btnLabel, heroImg, alvacVideo}) {



  const [typEffect] = useTypewriter({
    words: [ " Financial Security", "Cash Handling", "Trusted Solutions"],
    loop:{},
    typeSpeed: 100,
    deleteSpeed: 40,
  })
  return (
    <>
      <div className='hero-section' id='HeroSection'>
        <div className="container">
            <div className="hero-content">
              
              <div className="hero-tagline">
                  <p className='text'>{topline} <span>{toplineSpan}</span></p>
                  <img src="./images/tagline-image.svg" className='tagline-image' alt="" />

              </div>
                
                <div className="hero-text">
                    <h1>{headline} <span> and {typEffect}</span></h1>
                    <p className='text'>{description}.</p>
                    <Link
                      activeClass="active" 
                      to="Contact" 
                      spy={true} 
                      smooth={true} 
                      duration={500}
                      >
                      <button className='btn-large text'   
                       >{btnLabel}</button>
                       
                    </Link>
                </div>
               
        
                <VideoPlayer id="player1" src={alvacVideo} />
         
              
            </div>

        </div>
      </div>
    </>
  )
}

export default HeroSection
